"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComputerDirectory = void 0;
/**
 * Common folders often used in computers for storing files
 */
var ComputerDirectory;
(function (ComputerDirectory) {
    ComputerDirectory[ComputerDirectory["Documents"] = 0] = "Documents";
})(ComputerDirectory = exports.ComputerDirectory || (exports.ComputerDirectory = {}));
